'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('workorder-code-list', {
      url: '/workorder/code/list',
      template: '<work-order-code-list></work-order-code-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/workorders/code-list/workorders-code-list.routes.js